/**
 * Page numbers (1-based) to show in a fixed-size pagination strip.
 * When total pages exceed the window, the window slides: e.g. with 10 pages
 * and window 5, page 5 shows [5, 6, 7, 8, 9]; page 10 shows [6, 7, 8, 9, 10].
 */
export function getVisiblePaginationPages(
  currentPage: number,
  totalPages: number,
  windowSize = 5,
): number[] {
  if (totalPages <= 0) return [];
  const safeCurrent = Math.min(Math.max(1, currentPage), totalPages);
  if (totalPages <= windowSize) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  const maxStart = totalPages - windowSize + 1;
  const start = Math.min(safeCurrent, maxStart);
  return Array.from({ length: windowSize }, (_, i) => start + i);
}
